export const api = "/api";

export const transcoder = `${api}/Transcoder`;
export const records = "/records";
export const multipartUpload = "/create-multipart-upload";
export const signinPartUpload = "/sign-part-upload";
export const abortUpload = "/abort-multipart-upload";
export const completeMultipartUpload = "/complete-multipart-upload";

export const AI = `${api}/AI`;
export const teleprompter = "/teleprompter";

export const userRoot = `${api}/user`;
export const videoShareLink = `${api}/video/share_link`;
